module.exports = __webpack_public_path__ + "img/arrow-down-left-square-fill.5b575d67.svg";